import { route } from '../helpers';

import { NREPages } from '../../constants/AppConstants';

module.exports = route(NREPages.ORDER_LANDING, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/nre/OrderLanding').default);
        }, 'nre-order-landing');
    }
});



// WEBPACK FOOTER //
// ./src/routes/NRE/index.js